export function getPercentage(count: number, total:number) {
    if (!total || total === 0) return 0; 
    return Math.round((count / total) * 100);
}

export function getPercentageToTwoDecimals(count: number, total:number) {
    if (!total || total === 0) return 0; 
    return Math.round((count / total) * 100 * 100) / 100;
}

const numberFormatter = (num:number):string => {

    if (isNaN(num)){
        return "";
    }

    if(num > 999 && num < 1000000){

        // Over 100k
        if (num >= 100000){
            return parseFloat((num/1000).toFixed(0)).toString() + 'K'; 
        }

        return parseFloat((num/1000).toFixed(1)).toString() + 'K'; // convert to K for number from > 1000 < 1 million
        
    }else if(num >= 1000000){

        return parseFloat((num/1000000).toFixed(0)).toString() + 'M'; // convert to M for number from > 1 million 
    }

    return num.toString(); 
}

export {numberFormatter}